module.exports = __webpack_public_path__ + "img/2.ad009ac.jpg";